import { Action } from '@ngrx/store';
import {ModuleFilter} from '../module.model';

export enum ModuleFilterActionTypes {
  LoadModuleFilters = '[ModuleFilter] Load ModuleFilters',
}

export class LoadModuleFilters implements Action {
  readonly type = ModuleFilterActionTypes.LoadModuleFilters;
  constructor(public payload: ModuleFilter) {}
}


export type ModuleFilterActions = LoadModuleFilters;
